<template>
  <div class="tw-flex tw-flex-col tw-text-lg">
    <div class="tw-flex tw-gap-3">
      <div class="tw-flex tw-flex-col">
        <div>Include <span class="tw-font-semibold">Values</span> parameter<span class="tw-text-[#B3B9C6]"> (optional)</span></div>
        <div class="tw-flex tw-items-center tw-gap-3">
          <ValuesSelectWrapper
            :is-active="true"
            :selected-values="checkupStore.selectedValues"
            @update:selectedValues="updateSelectedValues"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AdvisorCoreCheckbox from '@frontend/ui/components/utils/AdvisorCoreCheckbox.vue';
import ValuesSelectWrapper from '@frontend/ui/features/checkup/components/portfolio-select/ValuesSelectWrapper.vue';
import { mapStores } from 'pinia';
import { useCheckupStore } from '@frontend/ui/stores/checkupStore';

export default {
  components: { AdvisorCoreCheckbox, ValuesSelectWrapper },
  data() {
    return {
    };
  },
  computed: {
    ...mapStores(useCheckupStore),
  },
  watch: {
    'checkupStore.personEntity': {
      handler() {
        if (this.checkupStore?.personEntity?.screen_sets) {
          const values = this.checkupStore?.personEntity?.screen_sets || [];
          this.checkupStore.selectedValues = values;
          this.updateSelectedValues(values); // Add this line
        }
      },
      immediate: true,
    },
  },
  created() {

  },
  methods: {
    updateSelectedValues(values) {
      this.checkupStore.setSelectedValues(values);
    },
  },
};
</script>

<style scoped>

</style>
